import { render, staticRenderFns } from "./ViewCouponClaims.vue?vue&type=template&id=6f017197&scoped=true"
import script from "./ViewCouponClaims.vue?vue&type=script&lang=js"
export * from "./ViewCouponClaims.vue?vue&type=script&lang=js"
import style0 from "./ViewCouponClaims.vue?vue&type=style&index=0&id=6f017197&prod&lang=css"
import style1 from "./ViewCouponClaims.vue?vue&type=style&index=1&id=6f017197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f017197",
  null
  
)

export default component.exports